import React from "react";

import cn from "classnames";

import { isDefined } from "@mapmycustomers/shared/util/assert";
import { LoadingSpinner } from "@mapmycustomers/ui";

import colors from "@app/styles/_colors.module.scss";
import anyColorToHex from "@app/util/colors/anyColorToHex";
import getContrastColor from "@app/util/colors/getContrastColor";

import styles from "./Card.module.scss";
import StageCard from "./StageCard";

interface Props extends StageCard {
  className?: string;
  index: number;
  loading?: boolean;
  totalCards: number;
}

const Card: React.FC<Props> = ({
  className,
  color,
  index,
  leftIndex,
  loading = false,
  name,
  rightIndex,
  selected,
  totalCards,
}) => {
  return (
    <div
      className={cn(
        styles.container,
        {
          [styles.left]: isDefined(leftIndex),
          [styles.leftmost]: index === 0,
          [styles.right]: isDefined(rightIndex),
          [styles.rightmost]: index === totalCards - 1,
          [styles.selected]: selected,
        },
        className
      )}
      style={{
        "--leftIndex": leftIndex,
        "--rightIndex": rightIndex,
        backgroundColor: anyColorToHex(color),
        color: getContrastColor(color) === "black" ? colors.slate : colors.white,
      }}
    >
      <span className={cn(styles.title, { [styles.loading]: loading })}>
        {name}
        {loading && <LoadingSpinner className={styles.spinner} />}
      </span>
    </div>
  );
};

export default Card;
